import http from "./http.js";

async function getUser(id) {
  try {
    const response = await http.get(`users/${id}`);
    return {
      title: response.data.title,
      name: response.data.name,
      email: response.data.email,
      role: response.data.role,
      comment: response.data.comment,
      clientId: response.data.clientId,
    };
  } catch (err) {
    throw err;
  }
}

async function updateUser(id, user) {
  try {
    const response = await http.put(`users/${id}`, user);
    return response;
  } catch (err) {
    throw err;
  }
}

async function createUser(user) {
  try {
    const response = await http.post("users", user);
    return response;
  } catch (err) {
    throw err;
  }
}

async function changePassword(id, password) {
  try {
    const response = await http.patch(`users/${id}/password`, password);
    return response;
  } catch (err) {
    throw err;
  }
}

async function getCurrentUser() {
  try {
    const response = await http.get("users/current");
    return {
      name: response.data.name,
      title: response.data.title,
      role: response.data.role,
    };
  } catch (err) {
    throw err;
  }
}

async function getUsers(
  page = 1,
  rowsPerPage = 9,
  searchTerm = "",
  filter = null
) {
  try {
    const requestParams = {
      params: {
        page,
        pageSize: rowsPerPage,
        searchTerm,
        userRole: filter?.role,
      },
    };

    const response = await http.get("users", requestParams);
    return response.data;
  } catch (err) {
    throw err;
  }
}

async function selectUser(page = 1, rowsPerPage = 9, search = "") {
  try {
    const response = await http.get("users/references", {
      params: {
        page,
        pageSize: rowsPerPage,
        searchTerm: search,
      },
    });
    return response.data;
  } catch (err) {
    throw err;
  }
}

export {
  getUser,
  updateUser,
  createUser,
  changePassword,
  getCurrentUser,
  getUsers,
  selectUser,
};
